module.exports = __webpack_public_path__ + "static/media/analytics-365-day-reports.9bb2e055.png";